import { useEffect, useState } from "react";
import delete_icon from './img/trash_icon.svg'
import edit_icon from './img/edit_icon.svg'
import { AuthorAvatar } from "../../ArticleComponents/AuthorAvatar/AuthorAvatar";
import check_double from './img/check-double.svg'
import './ChatPreview.scss'

const ChatPreview = (props) => {
    const [data, setData] = useState(props)

    const {
        chat,
        chat_id,
        name,
        members,
        currentMessage,
        setCurrentMessage,
        unread_messages_count,
        setIsModalCreateGroup,
        setIsEditGroup,
        type,
        deleteFunc = () => { },
        owner,
        chatListNotification,
        userStatus
    } = data

    const current_members = type == 'chat' ? (members?.[0] ? [members?.[0]] : []) : members
    const email = localStorage.getItem('email');
    const author_login = owner?.login
    const current_count = chatListNotification?.[data?.chat?.chat_id] || null

    useEffect(() => {
        setData(props)
    }, [props])

    return (
        <div
            className={currentMessage?.chat?.chat_id == data?.chat?.chat_id ? 'chat-preview_active' : 'chat-preview'}
            key={name + chat_id}
            onClick={(e) => {
                setCurrentMessage(props)
            }}
        >
            <div className='chat-preview__content'>
                <div className='chat-preview__content-title-members'>

                    {name && <h3 className='chat-preview__title'>{name}</h3>}
                    <div className='employees-container'>
                        {(current_members)?.map(({ name, login, color, id }) =>
                            <AuthorAvatar
                                size='s'
                                group
                                show_name={type == 'chat'}
                                key={name + login}
                                author={[name, color]}
                                showTooltip
                                isStatus={true}
                                status={userStatus.includes(id)}
                            />
                        )?.slice(0, 6)}

                        {(current_members?.length > 12) && <p className='sum_executor'>+<span>{current_members?.length - 12}</span></p>}
                    </div>
                </div>

                <div className='btn-group'>
                    {current_count
                        ?
                        <div className="chat-preview__count">
                            {current_count}
                        </div>
                        :
                        null
                    }

                    {(type != 'chat' && (email === author_login)) && <button className='btn-edit'
                        onClick={(e) => {
                            e.stopPropagation()
                            setCurrentMessage(props)
                            setIsEditGroup(true)
                            setIsModalCreateGroup(true)
                        }}
                    >
                        <img style={{ width: 18, height: 18 }} src={edit_icon} />
                    </button>}
                    <button className='btn-delete'
                        onClick={e => {
                            e.stopPropagation()
                            deleteFunc(chat?.chat_id)
                        }}
                    >
                        <img src={delete_icon} />
                    </button>
                </div>
            </div>
        </div>
    )
}


export { ChatPreview };
